import { storeService } from '@/domain/Store'
import { Modal, Select } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'

type Props = {
    opened: boolean
    close: () => void
}

const ListStoreModal = (props: Props) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ['vendors'],

        queryFn: async () =>
            storeService.list()
    })

    const router = useRouter()

    const selectStore = async (id: string) => {
        const url = new URL(window.location.href)
        if (id === 'null') {
            url.searchParams.delete('storeId')
        } else {
            url.searchParams.set('storeId', id)
        }

        // if we are not in the search page, we redirect to the search page
        if (router.pathname !== '/search') {
            router.push('/search' + url.search)
            props.close()

            return
        }

        // if we are in the search page, we just reload the page with the new query

        router.push(url.search)
        props.close()
    }

    return (
        <Modal.Root
            className="overflow-visible"
            centered
            opened={props.opened}
            onClose={props.close}
        >
            <Modal.Overlay />
            <Modal.Content className="overflow-visible">
                <Modal.Header>
                    <Modal.Title>
                        <div className="flex flex-col gap-0">
                            <span className="text-base font-medium text-gray-900">
                                Liste des magasins
                            </span>
                            <p className="mt-1 text-sm text-gray-500">
                                En sélectionnant un magasin, vous pourrez
                                naviguer dans les produits de ce magasin.
                            </p>
                        </div>
                    </Modal.Title>
                    <Modal.CloseButton className="absolute top-2 right-2" />
                </Modal.Header>
                <Modal.Body>
                    {isLoading && <div>Loading...</div>}
                    {isError && <div>Error</div>}
                    {!isLoading && !isError && !!data && (
                        <Select
                            zIndex={1000}
                            label="Sélectionner un magasin"
                            positionDependencies={[{ name: 'bottom' }]}
                            searchable
                            dropdownPosition="bottom"
                            nothingFound="Aucun magasin trouvé"
                            placeholder="ex. STOUX"
                            onChange={selectStore}
                            data={[
                                { label: 'Tous les magasins', value: 'null' },
                                ...data.map((store) => ({
                                    label: store.name || '',
                                    value: store.id || '',
                                })),
                            ]}
                        />
                    )}
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    )
}

export default ListStoreModal
